var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg20CurrencyCoinDollar = function Svg20CurrencyCoinDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#919191",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.203 8.168a1.43 1.43 0 0 0-.49-.674 1.4 1.4 0 0 0-.775-.28H9.062c-.372 0-.73.15-.994.419a1.45 1.45 0 0 0-.412 1.013c0 .38.148.744.412 1.013s.622.42.995.42h1.874c.373 0 .731.15.995.419a1.446 1.446 0 0 1 0 2.026c-.264.268-.621.419-.994.419H9.062a1.4 1.4 0 0 1-.776-.28 1.43 1.43 0 0 1-.49-.675M10 5.78v1.433m0 5.729v1.432M17.5 10a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0"
  })));
};
export default Svg20CurrencyCoinDollar;